module.exports = __webpack_public_path__ + "static/media/Circular Std Black.f1a22f6f.ttf";